import { InjectionToken } from '@angular/core';

export interface IParser {
  stringify<T>(item: T): string;
  parse<T>(item: string): T;
  parseInstance<T>(item: string, constructor: new (item: Partial<T>) => T): T;
}

export const IParserToken = new InjectionToken<IParser>('IParser');
